import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';

export const Title = styled.h1`
    ${Text.Full.heading2}
    color: ${cssVars.fg_black_white};
    margin: 0;

    ${Screen.ipad} {
        ${Text.Ipad.heading3};
    }
    ${Screen.desktop} {
    }
`;

export const Subtitle = styled.h1`
    ${Text.Full.large.medium};
    color: ${cssVars.fg_gray2_gray3};
    margin: 0;
`;

export const ActivityCardWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 13px auto 25px;

    ${Screen.ipad} {
        margin: 13px auto 45px;
    }

    ${Screen.desktop} {
        max-width: 520px;
    }
`;

export const CardWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 15px 0 0;
    width: 100%;

    ${Screen.ipad} {
        gap: 24px;
        padding: 6px 0 20px;
    }

    ${Screen.desktop} {
        gap: 24px;
        margin: 15px 0 0;
    }
`;

export const CardContainer = styled.div`
    display: flex;
    margin: 0 0 20px;
    position: relative;
    ${Screen.desktop} {
        margin: 0 0 30px;
    }
`;

export const LoaderContainer = styled.div`
    margin: 7vh auto;
`;
